<template>
  <b-navbar type="dark" variant="primary" sticky ref="navbar" class="nav-bar">
    <etu-nav-button class="mr-2"></etu-nav-button>
    <b-button
      v-b-toggle.main-sidebar
      class="mr-2"
      variant="primary"
      pill
      v-if="isAuthenticated"
    >
      <font-awesome-icon :icon="['fas', 'bars']" />
    </b-button>
    <b-navbar-brand :href="getHome">
      {{ buildTitle(isMobile) }}
    </b-navbar-brand>

    <b-navbar-nav class="ml-auto">
      <NotificationChangelog
        v-if="isAuthenticated"
        class="ml-1"
        :getHasUnread="getHasUnread_"
        @changelog="onRedirectChangelog"
      />
      <Login v-if="!isAuthenticated" />
      <Logout v-if="isAuthenticated" />
    </b-navbar-nav>
  </b-navbar>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'

import { navBarTitleMapper } from '@/store/modules/navbar'
import { userMappers } from '@/store/modules/user'
import Logout from '@/components/pages/home/components/navbar/components/Logout.vue'

import { mobileWidthMapper } from '@/store/modules/mobileWidth'
import Login from '@/components/pages/home/components/navbar/components/Login.vue'
import { clientBaseWithSlash } from '@/config/urls'
import { commonRouteNames, commonRouteURLs } from '@/router/pages/common'
import ChangeLogAPI from '@/components/routes/common/changelog/helpers/requests'

const Mappers = Vue.extend({
  computed: {
    ...mobileWidthMapper.mapGetters(['isMobile']),
    ...userMappers.mapGetters(['isAuthenticated']),
    ...navBarTitleMapper.mapGetters(['buildTitle'])
  }
})

@Component({
  components: { Login, Logout }
})
export default class Navbar extends Mappers {
  private getHasUnread_ = ChangeLogAPI.getHasUnread

  private get getHome() {
    return clientBaseWithSlash
  }

  private onRedirectChangelog() {
    this.$router.push(commonRouteURLs[commonRouteNames.ChangelogRoute])
  }
}
</script>

<style lang="scss">
@import '@/scss/_colors.scss';

.nav-bar {
  .navbar-brand {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
  .nav-item {
    background-color: inherit;
  }
  .nav-item:hover {
    background-color: map-get($french-palette, 'blue-4');
  }
}
</style>
